import { useQueryClient } from '@tanstack/react-query';
import { components } from 'src/generated/v1';
import { $api } from './api';

export type CasesSettings = components['schemas']['CasesSettings'];
export type CasesSettingsUpdate = components['schemas']['CasesSettingsUpdate'];
export type CasesSettingsIssue = components['schemas']['CasesSettingsIssue'];
export type CaseNotificationRecipient = components['schemas']['CaseNotificationRecipient'];

export const useCaseSettingsQuery = () => {
  return $api.useQuery('get', '/settings/cases');
};

export const useCaseSettingsRecipientsQuery = () => {
  return $api.useQuery('get', '/settings/cases/recipients');
};

export const useCaseSettingsUpdate = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('put', '/settings/cases', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/settings/cases'] });
    },
  });
};
